import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';



@Component({
  selector: 'app-tipo-de-vendedor',
  templateUrl: './tipo-de-vendedor.component.html',
  styleUrls: ['./tipo-de-vendedor.component.css']
})
export class TipoDeVendedorComponent implements OnInit {

  tituloCard: string = 'Tipo de Vendedor';
  tituloForm: string = 'Lista De Tipo de Vendedor';

  formulario: FormGroup;
  formularioFiltroEstadoDeVendedores: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbFiltroEstados: any[] = [
    {
      clave: '1',
      valor: 'ACTIVO'
    },
    {
      clave: '0',
      valor: 'INACTIVO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _tipoDeVendedor: TipoDeVendedorService,


  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idTipo: ['', null],
      descripcion: ['', [Validators.required, , Validators.maxLength(100)]],
      sueldoVariable: ['', [Validators.required]],
      unidadNegocio: ['', [Validators.required]],
      estado: ['', [Validators.required]],
      descripcionUnidadNegocio: ['', []],
    });

    this.formularioFiltroEstadoDeVendedores = this.fb.group({
      idEstadoVendedor: ['', []],
    });

    this.formularioFiltroEstadoDeVendedores.get('idEstadoVendedor').setValue("1");

    this.formularioFiltroEstadoDeVendedores.get('idEstadoVendedor').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.getEstadoDeVendedores(resp)
        }
      });

    this.cargarGridcomponent();
    // this.getTiposDeVendedores();
    this.getEstadoDeVendedores(1);
    this.unidadesNegocioSAP();

  }

  /* FUNCIONES */
  listUnidadesNegocioSAP;
  unidadesNegocioSAP() {
    this.loading = true;
    this._tipoDeVendedor.getUnidadesNegocioSAP().subscribe((res: any[]) => {
      console.log("getUnidadesNegocioSAP()", res)
      this.loading = false;
      this.listUnidadesNegocioSAP = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.listUnidadesNegocioSAP = [];
    });
  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'Id',
        field: 'idTipo',
        filter: true,
        sortable: true,
        // width: 120,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Descripcion',
        field: 'descripcion',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Sueldo Variable',
        field: 'sueldoVariable',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'Estado',
        field: 'estado',
        sortable: true,
        // width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.reset();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Tipo de Vendedor';
  }

  editar({ rowData }) {
    console.log("editar", rowData)
    this.formulario.reset();
    this.formulario.setValue(rowData);
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Tipo de Vendedores';
    this.tituloForm = 'Lista De Tipo de Vendedores';
  }

  /** SERVICIOS */
  getTiposDeVendedores() {
    this.listaVacia = true;
    this.loading = true;

    this._tipoDeVendedor.getTiposDeVendedores().subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._tipoDeVendedor.deleteTipoDeVendedore(rowData.idTipo),
      })
      .then((res: any) => {
        this.getTiposDeVendedores();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._tipoDeVendedor.saveTipoDeVendedore(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTiposDeVendedores();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar")

    console.log(this.formulario.getRawValue())
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._tipoDeVendedor.updateTipoDeVendedore(this.formulario.getRawValue()),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTiposDeVendedores();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  listTiposDeVendedores;
  getEstadoDeVendedores(estado) {
    this.listaVacia = true;
    this.loading = true;
    this._tipoDeVendedor.getTiposDeVendedoresPorEstado(estado).subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.listaVacia = true;
      this.rowData = [];
    });
  }

}
